import { FILTER_TYPES } from 'components/FilterPod';

const filters = (getCredit) => [
  {
    title: 'شناسه درخواست',
    label: 'شناسه درخواست',
    keyName: 'entityId',
    query: 'entityId',
    id: 1,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
   {
    title: 'مرحله',
    label: 'مرحله',
    keyName: 'warrantySteps',
    query: 'warrantySteps',
    id: 16490,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          value: ['INFO', 'EDIT_INFO', 'REGISTER_INQUIRY'],
          label: 'استعلام مدارک',
        },

        {
          value: ['REGISTER_COLLATERAL', 'COLLATERAL_INQUIRY'],
          label: 'بررسی وثیقه',
        },
        {
          value: ['REGISTER_CONTRACT', 'SIGNATURE_CONTRACT'],
          label: 'ایجاد و امضا قرارداد',
        },

        {
          value: ['FILING'],
          label: 'تشکیل پرونده',
        },
        {
          value: ['REGISTERED', 'PENDING_TO_REGISTER', 'UNREGISTERED'],
          label: 'صدور ضمانت‌نامه',
        },
      ],
    },
  },
  {
    title: 'مهلت تکمیل اطلاعات',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'date',
    id: {
      start: 1647,
      end: 1648,
    },
    query: {
      start: 'fromDueDate',
      end: 'toDueDate',
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
  },

  {
    title: 'نوع ضمانت‌نامه',
    label: 'نوع ضمانت‌نامه',
    keyName: 'warrantyType',
    query: 'warrantyType',
    id: 1649,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          value: ['PARTICIPATION_TENDERS', 'CASH_PARTICIPATION_TENDERS'],
          label: 'شرکت در مناقصه',
        },
      ],
    },
  },
  {
    title: 'وضعیت',
    label: 'وضعیت',
    keyName: 'warrantyStatuses',
    query: 'warrantyStatuses',
    id: 16490,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          value: ['EXPIRED'],
          label: 'منقضی شده',
        },
        {
          value: ['REJECTED'],
          label: 'رد شده',
        },
        {
          value: ['CREATED'],
          label: 'ایجاد شده',
        },
        {
          value: ['CANCELED'],
          label: 'لغو شده',
        },
        {
          value: ['INCOMPLETE'],
          label: 'تکمیل نشده ',
        },
        {
          value: ['WAITING'],
          label: 'در انتظار',
        },
        {
          value: ['ERROR'],
          label: 'خطا',
        },

      ],
    },
  },
 
];

export default filters;
